import {
  Bucket,
  Database,
  Disk,
  Network,
  Project,
  SuccessOperation,
} from "@gravity-ui/illustrations";
import { Button, Flex } from "@gravity-ui/uikit";
import { motion } from "framer-motion";
import { POIZON_API_BOT_LINK } from "src/constants/links";
import { useGravityDevice } from "src/hooks/useGravityDevice";
import { T, useTranslate } from "src/i18n";

import { TextSection } from "../TextSection";
import { AdvantageCard } from "./components";

export const AdvantagesBlock = () => {
  const { isMobile } = useGravityDevice();
  const { t } = useTranslate();

  return (
    <Flex
      id="advantages"
      direction={"column"}
      width={"100%"}
      maxWidth={"1440px"}
      style={{
        paddingLeft: isMobile ? 30 : 50,
        paddingRight: isMobile ? 30 : 50,
        gap: 60,
      }}
    >
      <TextSection
        title={t("landing.advantages_block.title", "Преимущества")}
        description={t(
          "landing.advantages_block.description",
          "Наши преимущества очень сильно выделяются на фоне конкурентов, узнать все наши услуги вы можете у менеджера",
        )}
      />
      <Flex
        wrap={"wrap"}
        justifyContent={isMobile ? "center" : "space-between"}
        gap={4}
      >
        <AdvantageCard
          title={t(
            "landing.advantages_block.card.1.title",
            "Быстрая загрузка товаров",
          )}
          description={t(
            "landing.advantages_block.card.1.description",
            "Загружаем до 1 000 товаров в минуту, обновление данных каждую минуту",
          )}
          animate={{ transition: { delay: 0 } }}
        >
          <motion.div
            initial={{ scale: 0.2, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.2, opacity: 0 }}
            viewport={{ once: true }}
            transition={{
              delay: 0.2,
              duration: 0.1,
              type: "spring",
              damping: 10,
            }}
          >
            <Disk height={isMobile ? 120 : 180} width={isMobile ? 120 : 180} />
          </motion.div>
        </AdvantageCard>
        <AdvantageCard
          title={t(
            "landing.advantages_block.card.2.title",
            "Легкая интеграция",
          )}
          description={t(
            "landing.advantages_block.card.2.description",
            "Предоставляем подробную документацию и посянения по всем типам данных",
          )}
          animate={{ transition: { delay: 0.1 } }}
        >
          <motion.div
            initial={{ scale: 0.2, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.2, opacity: 0 }}
            viewport={{ once: true }}
            transition={{
              delay: 0.2,
              duration: 0.3,
              type: "spring",
              damping: 10,
            }}
          >
            <motion.div
              initial={{ scale: 0.2, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.2, opacity: 0 }}
              viewport={{ once: true }}
              transition={{
                delay: 0.2,
                duration: 0.1,
                type: "spring",
                damping: 10,
              }}
            >
              <Bucket
                height={isMobile ? 120 : 180}
                width={isMobile ? 120 : 180}
              />
            </motion.div>
          </motion.div>
        </AdvantageCard>
        <AdvantageCard
          title={t(
            "landing.advantages_block.card.3.title",
            "Гибкое ценообразование",
          )}
          description={t(
            "landing.advantages_block.card.3.description",
            "Выберите тариф под себя или обсудите с нами индивидуальные условия",
          )}
          animate={{ transition: { delay: 0.2 } }}
        >
          <motion.div
            initial={{ scale: 0.2, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.2, opacity: 0 }}
            viewport={{ once: true }}
            transition={{
              delay: 0.2,
              duration: 0.1,
              type: "spring",
              damping: 10,
            }}
          >
            <Database
              height={isMobile ? 120 : 180}
              width={isMobile ? 120 : 180}
            />
          </motion.div>
        </AdvantageCard>
        <AdvantageCard
          title={t(
            "landing.advantages_block.card.4.title",
            "Точный перевод карточки товара",
          )}
          description={t(
            "landing.advantages_block.card.4.description",
            "Перевод с китайского или английского. Есть функционал авто отброса иероглифов",
          )}
          animate={{ transition: { delay: 0.3 } }}
        >
          <motion.div
            initial={{ scale: 0.2, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.2, opacity: 0 }}
            viewport={{ once: true }}
            transition={{
              delay: 0.2,
              duration: 0.1,
              type: "spring",
              damping: 10,
            }}
          >
            <Project
              height={isMobile ? 120 : 180}
              width={isMobile ? 120 : 180}
            />
          </motion.div>
        </AdvantageCard>
        <AdvantageCard
          title={t(
            "landing.advantages_block.card.5.title",
            "Надёжность и поддержка",
          )}
          description={t(
            "landing.advantages_block.card.5.description",
            "Задайте вопрос службе поддержки или подключите нашего специалиста для решения проблемы",
          )}
          animate={{ transition: { delay: 0.4 } }}
        >
          <motion.div
            initial={{ scale: 0.2, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.2, opacity: 0 }}
            viewport={{ once: true }}
            transition={{
              delay: 0.2,
              duration: 0.1,
              type: "spring",
              damping: 10,
            }}
          >
            <SuccessOperation
              height={isMobile ? 120 : 180}
              width={isMobile ? 120 : 180}
            />
          </motion.div>
        </AdvantageCard>
        <AdvantageCard
          title={t(
            "landing.advantages_block.card.6.title",
            "Интеграция с любой CMS",
          )}
          description={t(
            "landing.advantages_block.card.6.description",
            "InSales, WooCommerce, Tilda и индивидуальные решения",
          )}
          animate={{ transition: { delay: 0.5 } }}
        >
          <motion.div
            initial={{ scale: 0.2, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.2, opacity: 0 }}
            viewport={{ once: true }}
            transition={{
              delay: 0.2,
              duration: 0.1,
              type: "spring",
              damping: 10,
            }}
          >
            <Network
              height={isMobile ? 120 : 180}
              width={isMobile ? 120 : 180}
            />
          </motion.div>
        </AdvantageCard>
      </Flex>
      <Button
        href={POIZON_API_BOT_LINK}
        target="_blank"
        view="flat-action"
        size="xl"
        width="max"
        selected
        style={{ maxWidth: isMobile ? "100%" : 300, margin: "0 auto" }}
      >
        <T
          keyName={"landing.advantages_block.button"}
          defaultValue={"Узнать обо всех услугах"}
        />
      </Button>
    </Flex>
  );
};
